import { Component, OnInit, Input, EventEmitter, Output, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ReadOnlyProperty } from '../../../shared/ui/control-options/control-option.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { INotificationService } from '../../../shared/services/inotification.service';
import { SecurityPermissionSelect } from '../../../shared/ui/select-controls/security-permission.model';
import { SecurityRolePermission } from '../../../shared/interfaces/entities/security-role-permission.interface';
import { faRefresh, faSave } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-security-role-permission',
    templateUrl: './security-role-permission.component.html',
    styleUrls: ['./security-role-permission.component.css'],
    standalone: false
})
export class SecurityRolePermissionComponent implements OnInit {

  @Input() entity: SecurityRolePermission;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  saveIcon = faSave;
  saving : boolean = false;

  securityPemissionSelect: SecurityPermissionSelect;

  constructor(private fb: FormBuilder,
              private notificationService: INotificationService) { }

  public form: FormGroup;

  ngOnInit(): void {
    var isNew: boolean = this.entity == undefined || this.entity == null || this.entity.id == undefined || this.entity.id == 0;

    var securityPemissionValue = { id: this.entity.securityPermissionId, name: this.entity.securityPermission_Name }
    this.securityPemissionSelect = new SecurityPermissionSelect("securityPermissionId", "Security Permission", securityPemissionValue);

    if (!isNew) {
      this.securityPemissionSelect.addOption(new ReadOnlyProperty());
      // Get the other options that can be selected

      var obj = {
        value: { id: this.entity.securityPermissionId }
      };
    } else {
      this.entity.id = 0;
      var securityRoleId = Number(window.location.pathname.split('/').at(-1));
      this.entity.securityRoleId = securityRoleId;
    }

    this.form = this.fb.group({
      id: [this.entity.id],
      securityPermission_Name: [this.entity.securityPermission_Name],
      securityPermissionId: [this.entity.securityPermissionId],
      securityRoleId: [this.entity.securityRoleId]
    });
  }

  save() {
    var securityPermissionId = this.securityPemissionSelect.getValue();

    if (securityPermissionId == undefined || securityPermissionId == null || securityPermissionId.length == 0) {
      var l = document.getElementById(this.securityPemissionSelect.id);
      if (l) {
        l.style.border = "2px solid orangered";
      }
      return;
    } else {
      this.saving = true;

      this.form.controls['securityPermissionId'].setValue(securityPermissionId);
      this.form.controls['securityRoleId'].setValue(this.entity.securityRoleId);

      this.submitForm.emit(this.form);
    }

  }
}
